<template>
  <div class="menu-image">
    <responsive-image
      class="menu-image__image"
      :image="image"
      :sizes="sizes"
      :ratio="ratio"
      :tag="getLinkComponent()"
      :href="image.url"
    />

    <component
      :is="getLinkComponent('span')"
      v-if="image.headingText"
      :href="image.url"
      class="menu-image__heading text-body-m-medium"
      v-text="image.headingText"
    />

    <btn
      v-if="image.linkText"
      modifiers="text"
      :label="image.linkText"
      :url="image.url"
    />
  </div>
</template>

<script>
import ResponsiveImage from '~global/images/responsive-image'
import Btn from '~global/btn/btn'

export default {
  name: 'MenuImage',

  components: {
    ResponsiveImage,
    Btn,
  },

  props: {
    image: {
      type: Object,
      default: () => ({
        alt: '',
        src: '',
        url: '',
        linkText: '',
        headingText: '',
      }),
    },
    ratio: {
      type: String,
      default: '7:6',
    },
    sizes: {
      type: String,
      default: '420px',
    },
  },

  methods: {

    /**
     * Get link component.
     * @param {string} fallback
     * @returns {string}
     */
    getLinkComponent(fallback = 'div') {
      return this.image.url ? 'a' : fallback
    },
  },
}
</script>
